import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { GetGuidService } from './get-guid.service';
import { addCreditCard, addCreditCardResponse, EditCreditCard, EditCreditCardResponse, 
        getTokenPage, getTokenPageResponse, getTokenPageResponseData,
        getEditTokenPage, getEditTokenPageResponse, getEditTokenPageResponseData,
          ListCreditCardsRequest, ListCreditCardsResponse, DeleteCreditCardPPIRequest, DeleteCreditCardPPIResponse,
          GetPaymentMethodsRequest, GetPaymentMethodsResponse,
          DeletePaymentMethodRequest, DeletePaymentMethodResponse,
          NotifyCreditCardAddRequest, NotifyCreditCardAddResponse, NotifyCreditCardEditRequest, NotifyCreditCardEditResponse,
          NotifyTokenAddRequest, NotifyTokenAddResponse, NotifyTokenEditRequest, NotifyTokenEditResponse } from '../../models/authorizeNet.model'
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class AuthorizePaymentService {

  private dwGetNewTokenPageApiUrl = ApiEndpoints.dwGetNewTokenPage;
  private dwGetEditTokenPageApiUrl = ApiEndpoints.dwGetEditTokenPage;
  private dwNotifyTokenAddApiUrl = ApiEndpoints.dwNotifyTokenAdd;
  private dwNotifyTokenEditApiUrl = ApiEndpoints.dwNotifyTokenEdit;
  private dwDeletePaymentMethodUrl = ApiEndpoints.dwDeletePaymentMethod;
  private dwGetPaymentMethodUrl = ApiEndpoints.dwGetPaymentMethod;

  private PPAddCreditCardApiUrl = ApiEndpoints.PPIAddCreditCard; 
  private PPEditCreditCardApiUrl = ApiEndpoints.PPIEditCreditCard;
  private PPIListCreditCardApiUrl = ApiEndpoints.PPIListCreditCard;
  private PPIDeleteCreditCardApiUrl = ApiEndpoints.PPIDeleteCreditCard;
  private PPINotifyCreditCardAddApiUrl = ApiEndpoints.PPINotifyCreditCardAdd;
  private PPINotifyCreditCardEditApiUrl = ApiEndpoints.PPINotifyCreditCardEdit;

  constructor(private http: HttpClient,public getheader:GetGuidService) { }

   // Add Credit Card 
  addCreditCard(addcreditcard:addCreditCard): Observable<addCreditCardResponse> {
    // Construct the request body according to the API's expected format
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    return this.http.post<addCreditCardResponse>(this.PPAddCreditCardApiUrl, addcreditcard,httpOptions);
  }

  getNewTokenPage(getTokenPage:getTokenPage): Observable<getTokenPageResponse> {
    // Construct the request body according to the API's expected format
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    return this.http.post<getTokenPageResponse>(this.dwGetNewTokenPageApiUrl, getTokenPage,httpOptions);
  }


   // --- METHOD FOR EDIT CREDIT CARD ---
  editCreditCard(editcreditcard: EditCreditCard): Observable<EditCreditCardResponse> {
    let wallettoken = sessionStorage.getItem("walletheaders");
       console.log('EditCreditCard API - Retrieved wallettoken:', wallettoken); // <--- ADD THIS LINE FOR DEBUGGING
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    return this.http.post<EditCreditCardResponse>(this.PPEditCreditCardApiUrl, editcreditcard, httpOptions);
  }

    getEditTokenPage(getEditTokenPage: getEditTokenPage): Observable<getEditTokenPageResponse> {
    let wallettoken = sessionStorage.getItem("walletheaders");
       console.log('EditTokenPage API - Retrieved wallettoken:', wallettoken); // <--- ADD THIS LINE FOR DEBUGGING
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    return this.http.post<getEditTokenPageResponse>(this.dwGetEditTokenPageApiUrl, getEditTokenPage, httpOptions);
  }


/**
   * Fetches the list of credit cards for PPI users.
   * @param request The payload containing userid and customerid.
   * @returns Observable of ListCreditCardsResponse.
   */

  listCreditCards(request: ListCreditCardsRequest): Observable<ListCreditCardsResponse> {
    const wallettoken = sessionStorage.getItem("walletheaders");
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET", // Ensure POST is allowed
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      })
      
    };
    console.log('AuthorizePaymentService: Calling PPIListCreditCard API (POST) with body:', request);
    // CRITICAL FIX: Changed to .post() and pass 'request' as the body
    return this.http.post<ListCreditCardsResponse>(this.PPIListCreditCardApiUrl, request, httpOptions);
  }


  // Get Payment Methods

  getPaymentMethods(request: GetPaymentMethodsRequest): Observable<GetPaymentMethodsResponse> {
  const wallettoken = sessionStorage.getItem("walletheaders");
  const httpOptions = {
    headers: new HttpHeaders({
      "Access-Control-Allow-Methods": "POST, GET",
      'Content-Type': 'application/json',
      "Authorization": "bearer " + wallettoken
    })
  };

  console.log('AuthorizePaymentService: Calling DWGetPaymentMethod API with body:', request);
  return this.http.post<GetPaymentMethodsResponse>(this.dwGetPaymentMethodUrl, request, httpOptions);
}


   /**
   * Deletes a credit card for PPI users.
   * @param request The payload containing userCreditCardID, userid, and customerid.
   * @returns Observable of DeleteCreditCardPPIResponse (or ListCreditCardsResponse if API returns remaining list).
   */
  deleteCreditCardPPI(request: DeleteCreditCardPPIRequest): Observable<DeleteCreditCardPPIResponse> {
    const wallettoken = sessionStorage.getItem("walletheaders");
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET, DELETE", // Ensure DELETE is allowed if it's a DELETE verb, or POST if it's a POST verb for deletion
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      })
    };
    console.log('AuthorizePaymentService: Calling PPIDeleteCreditCard API (POST) with body:', request);
    // Assuming PPIDeleteCreditCard is a POST endpoint that takes a body
    return this.http.post<DeleteCreditCardPPIResponse>(this.PPIDeleteCreditCardApiUrl, request, httpOptions);
  }

    deletePaymentMethod(request: DeletePaymentMethodRequest): Observable<DeletePaymentMethodResponse> {
    const wallettoken = sessionStorage.getItem("walletheaders");
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET, DELETE",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      })
    };
    console.log('AuthorizePaymentService: Calling DWDeletePaymentMethod API (POST) with body:', request);
    return this.http.post<DeletePaymentMethodResponse>(this.dwDeletePaymentMethodUrl, request, httpOptions);
  }

    /**
   * Notifies the backend after a credit card has been successfully added via Authorize.Net.
   * @param request The payload containing userid and customerid.
   * @returns Observable of NotifyCreditCardAddResponse.
   */
  notifyCreditCardAdd(request: NotifyCreditCardAddRequest): Observable<NotifyCreditCardAddResponse> {
    const wallettoken = sessionStorage.getItem("walletheaders");
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET", // Assuming POST is used for notification
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      })
    };
    console.log('AuthorizePaymentService: Calling PPINotifyCreditCardAdd API (POST) with body:', request);
    return this.http.post<NotifyCreditCardAddResponse>(this.PPINotifyCreditCardAddApiUrl, request, httpOptions);
  }

   /**
   * Notifies the backend after a credit card has been successfully edited via Authorize.Net.
   * @param request The payload containing userid, customerid, and userCreditCardID.
   * @returns Observable of NotifyCreditCardEditResponse.
   */
  notifyCreditCardEdit(request: NotifyCreditCardEditRequest): Observable<NotifyCreditCardEditResponse> {
    const wallettoken = sessionStorage.getItem("walletheaders");
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET", // Assuming POST is used for notification
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      })
    };
    console.log('AuthorizePaymentService: Calling PPINotifyCreditCardEdit API (POST) with body:', request);
    return this.http.post<NotifyCreditCardEditResponse>(this.PPINotifyCreditCardEditApiUrl, request, httpOptions);
  }

  // NotifyTokenAdd

  notifyTokenAdd(request: NotifyTokenAddRequest): Observable<NotifyTokenAddResponse> {
  const wallettoken = sessionStorage.getItem("walletheaders");
  const httpOptions = {
   headers: new HttpHeaders({
    "Access-Control-Allow-Methods": "POST, GET",
    'Content-Type': 'application/json',
    "Authorization": "bearer " + wallettoken
   })
  };
  console.log('AuthorizePaymentService: Calling DWNotifyTokenAdd API (POST) with body:', request);
  return this.http.post<NotifyTokenAddResponse>(this.dwNotifyTokenAddApiUrl, request, httpOptions);
 }

 //NotifyTokenEdit

 notifyTokenEdit(request: NotifyTokenEditRequest): Observable<NotifyTokenEditResponse> {
  const wallettoken = sessionStorage.getItem("walletheaders");
  const httpOptions = {
   headers: new HttpHeaders({
    "Access-Control-Allow-Methods": "POST, GET",
    'Content-Type': 'application/json',
    "Authorization": "bearer " + wallettoken
   })
  };
  console.log('AuthorizePaymentService: Calling DWNotifyTokenEdit API (POST) with body:', request);
  return this.http.post<NotifyTokenEditResponse>(this.dwNotifyTokenEditApiUrl, request, httpOptions);
 }


}
